var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var ResponsiveImage = function (_a) {
    var sources = _a.sources, src = _a.src, alt = _a.alt, Image = _a.as, restProps = __rest(_a, ["sources", "src", "alt", "as"]);
    return (React.createElement("picture", null,
        !!sources &&
            sources.map(function (source) { return (React.createElement("source", { key: source.srcSet, srcSet: source.srcSet, media: source.media, type: source.type })); }),
        Image ? React.createElement(Image, __assign({ src: src, alt: alt }, restProps)) : React.createElement("img", __assign({ src: src, alt: alt }, restProps))));
};
export default ResponsiveImage;
